import axiosp from './src/core'

export default axiosp
